import { render, staticRenderFns } from "./TurboOutbound.vue?vue&type=template&id=116ac0d8"
import script from "./TurboOutbound.vue?vue&type=script&lang=js"
export * from "./TurboOutbound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports